import styled from 'styled-components';

const PageWrapper = styled.article`
    height: 100vh;
    flex-grow: 1;
    overflow: auto;
    padding: 20px;
    box-sizing: border-box;
`;

export default PageWrapper;
